import { Component, Input } from '@angular/core';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { CommonModule } from '@angular/common';

import { CommodityOfferLabelComponent } from '../../shared/commodity-offer-label/commodity-offer-label.component';

@Component({
  selector: 'ed-commodity-offer-header',
  templateUrl: './commodity-offer-header.component.html',
  styleUrls: ['./commodity-offer-header.component.ed.scss'],
  standalone: true,
  imports: [CommodityOfferLabelComponent, RoundedCurrencyPipe, CommonModule],
})
export class CommodityOfferEDHeaderComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() duration?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() productTitle?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() productSubTitle?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() price?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() priceDurationLabel?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() priceDurationAlternateLabel?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() incentive?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() highlight?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() dynamicPricingTitle?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showPriceTag?: boolean = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingHighlight = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingIncentive = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isDynamicProduct = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles?: boolean = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() withDiscountAlternateLabel?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantA? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() termijnbedragVariantB? = false;
}
